// ============================================================
// DATOS DE ARS93 — reguladores de Santa Coloma de Gramenet.
// GENERADO por tools/gen-reguladores-scg.py — NO editar a mano.
// Fuente: ScgCoordenadas.xlsx (79 reguladores).
//
// REAL:        ID y posición (cabinet) de cada regulador.
// SINTÉTICO:   grupos, fases, colores, phaseOffset y el nombre
//              "Regulador N" — el Excel no trae topología ni nombres
//              de calle. Un regulador real puede controlar varios
//              cruces (grupos en 16 o 32, no solo 4) —
//              cada grupo converge a su posición real en cuanto se cablea
//              a un semáforo OSM (Modo Edición). Regenerar cuando ARS93
//              entregue esos datos.
// ============================================================

import type { IntersectionDefinition } from '../types/intersection';
import { ColorCode as CC } from '../types/intersection';

// Geometría vacía compartida por todos los cruces.
const EMPTY_GEOMETRY: IntersectionDefinition['geometry'] = {
  lanes: [],
  crosswalks: [],
  intersectionArea: {
    type: 'Feature',
    properties: { id: 'area' },
    geometry: { type: 'Polygon', coordinates: [[]] },
  },
};

export const santaColomaIntersections: IntersectionDefinition[] = [
  {
    id: 'scg-reg-24',
    name: 'Regulador 24',
    center: [2.206324, 41.455317],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.206324, 41.455317], logicalId: 24, physicalId: 'SCG-R24' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.206504, 41.455317], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.206144, 41.455317], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.206324, 41.455447], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.206324, 41.455187], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.206504, 41.456417], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.206144, 41.456417], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.206324, 41.456547], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.206324, 41.456287], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.207604, 41.455317], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.207244, 41.455317], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.207424, 41.455447], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.207424, 41.455187], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.206504, 41.454217], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.206144, 41.454217], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.206324, 41.454347], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.206324, 41.454087], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-23',
    name: 'Regulador 23',
    center: [2.205075, 41.45451],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.205075, 41.45451], logicalId: 23, physicalId: 'SCG-R23' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.205255, 41.45451], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.204895, 41.45451], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.205075, 41.45464], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.205075, 41.45438], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.205255, 41.45561], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.204895, 41.45561], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.205075, 41.45574], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.205075, 41.45548], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.206355, 41.45451], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.205995, 41.45451], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.206175, 41.45464], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.206175, 41.45438], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.205255, 41.45341], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.204895, 41.45341], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.205075, 41.45354], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.205075, 41.45328], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-31',
    name: 'Regulador 31',
    center: [2.204988, 41.455695],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.204988, 41.455695], logicalId: 31, physicalId: 'SCG-R31' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.205168, 41.455695], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.204808, 41.455695], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.204988, 41.455825], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.204988, 41.455565], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.205168, 41.456795], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.204808, 41.456795], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.204988, 41.456925], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.204988, 41.456665], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.206268, 41.455695], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.205908, 41.455695], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.206088, 41.455825], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.206088, 41.455565], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.205168, 41.454595], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.204808, 41.454595], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.204988, 41.454725], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.204988, 41.454465], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-30',
    name: 'Regulador 30',
    center: [2.20612, 41.456436],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.20612, 41.456436], logicalId: 30, physicalId: 'SCG-R30' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.2063, 41.456436], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.20594, 41.456436], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.20612, 41.456566], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.20612, 41.456306], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.2063, 41.457536], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.20594, 41.457536], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.20612, 41.457666], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.20612, 41.457406], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.2074, 41.456436], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.20704, 41.456436], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.20722, 41.456566], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.20722, 41.456306], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.2063, 41.455336], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.20594, 41.455336], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.20612, 41.455466], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.20612, 41.455206], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-22',
    name: 'Regulador 22',
    center: [2.20457, 41.452768],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.20457, 41.452768], logicalId: 22, physicalId: 'SCG-R22' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.20475, 41.452768], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.20439, 41.452768], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.20457, 41.452898], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.20457, 41.452638], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.20475, 41.453868], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.20439, 41.453868], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.20457, 41.453998], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.20457, 41.453738], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.20585, 41.452768], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.20549, 41.452768], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.20567, 41.452898], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.20567, 41.452638], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.20475, 41.451668], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.20439, 41.451668], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.20457, 41.451798], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.20457, 41.451538], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-29',
    name: 'Regulador 29',
    center: [2.208162, 41.457881],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.208162, 41.457881], logicalId: 29, physicalId: 'SCG-R29' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.208342, 41.457881], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.207982, 41.457881], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.208162, 41.458011], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.208162, 41.457751], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.208342, 41.458981], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.207982, 41.458981], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.208162, 41.459111], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.208162, 41.458851], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.209442, 41.457881], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.209082, 41.457881], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.209262, 41.458011], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.209262, 41.457751], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.208342, 41.456781], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.207982, 41.456781], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.208162, 41.456911], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.208162, 41.456651], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-28',
    name: 'Regulador 28',
    center: [2.20901, 41.458403],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.20901, 41.458403], logicalId: 28, physicalId: 'SCG-R28' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.20919, 41.458403], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.20883, 41.458403], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.20901, 41.458533], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.20901, 41.458273], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.20919, 41.459503], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.20883, 41.459503], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.20901, 41.459633], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.20901, 41.459373], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.21029, 41.458403], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.20993, 41.458403], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.21011, 41.458533], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.21011, 41.458273], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.20919, 41.457303], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.20883, 41.457303], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.20901, 41.457433], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.20901, 41.457173], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-27',
    name: 'Regulador 27',
    center: [2.209718, 41.457913],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.209718, 41.457913], logicalId: 27, physicalId: 'SCG-R27' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.209898, 41.457913], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.209538, 41.457913], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.209718, 41.458043], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.209718, 41.457783], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.209898, 41.459013], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.209538, 41.459013], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.209718, 41.459143], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.209718, 41.458883], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.210998, 41.457913], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.210638, 41.457913], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.210818, 41.458043], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.210818, 41.457783], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.209898, 41.456813], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.209538, 41.456813], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.209718, 41.456943], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.209718, 41.456683], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-25',
    name: 'Regulador 25',
    center: [2.208544, 41.457043],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.208544, 41.457043], logicalId: 25, physicalId: 'SCG-R25' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.208724, 41.457043], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.208364, 41.457043], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.208544, 41.457173], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.208544, 41.456913], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.208724, 41.458143], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.208364, 41.458143], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.208544, 41.458273], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.208544, 41.458013], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.209824, 41.457043], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.209464, 41.457043], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.209644, 41.457173], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.209644, 41.456913], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.208724, 41.455943], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.208364, 41.455943], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.208544, 41.456073], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.208544, 41.455813], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-73',
    name: 'Regulador 73',
    center: [2.254906, 41.460894],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.254906, 41.460894], logicalId: 73, physicalId: 'SCG-R73' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.255086, 41.460894], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.254726, 41.460894], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.254906, 41.461024], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.254906, 41.460764], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.255086, 41.461994], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.254726, 41.461994], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.254906, 41.462124], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.254906, 41.461864], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.256186, 41.460894], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.255826, 41.460894], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.256006, 41.461024], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.256006, 41.460764], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.255086, 41.459794], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.254726, 41.459794], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.254906, 41.459924], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.254906, 41.459664], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-26',
    name: 'Regulador 26',
    center: [2.209117, 41.456297],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.209117, 41.456297], logicalId: 26, physicalId: 'SCG-R26' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.209297, 41.456297], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.208937, 41.456297], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.209117, 41.456427], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.209117, 41.456167], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.209297, 41.457397], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.208937, 41.457397], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.209117, 41.457527], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.209117, 41.457267], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.210397, 41.456297], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.210037, 41.456297], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.210217, 41.456427], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.210217, 41.456167], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.209297, 41.455197], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.208937, 41.455197], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.209117, 41.455327], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.209117, 41.455067], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-92',
    name: 'Regulador 92',
    center: [2.207915, 41.459513],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.207915, 41.459513], logicalId: 92, physicalId: 'SCG-R92' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.208095, 41.459513], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.207735, 41.459513], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.207915, 41.459643], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.207915, 41.459383], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.208095, 41.460613], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.207735, 41.460613], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.207915, 41.460743], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.207915, 41.460483], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.209195, 41.459513], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.208835, 41.459513], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.209015, 41.459643], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.209015, 41.459383], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.208095, 41.458413], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.207735, 41.458413], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.207915, 41.458543], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.207915, 41.458283], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-93',
    name: 'Regulador 93',
    center: [2.207346, 41.459199],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.207346, 41.459199], logicalId: 93, physicalId: 'SCG-R93' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.207526, 41.459199], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.207166, 41.459199], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.207346, 41.459329], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.207346, 41.459069], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.207526, 41.460299], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.207166, 41.460299], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.207346, 41.460429], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.207346, 41.460169], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.208626, 41.459199], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.208266, 41.459199], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.208446, 41.459329], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.208446, 41.459069], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.207526, 41.458099], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.207166, 41.458099], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.207346, 41.458229], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.207346, 41.457969], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-71',
    name: 'Regulador 71',
    center: [2.201096, 41.451987],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.201096, 41.451987], logicalId: 71, physicalId: 'SCG-R71' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.201276, 41.451987], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.200916, 41.451987], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.201096, 41.452117], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.201096, 41.451857], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.201276, 41.453087], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.200916, 41.453087], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.201096, 41.453217], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.201096, 41.452957], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.202376, 41.451987], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.202016, 41.451987], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.202196, 41.452117], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.202196, 41.451857], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.201276, 41.450887], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.200916, 41.450887], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.201096, 41.451017], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.201096, 41.450757], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-32',
    name: 'Regulador 32',
    center: [2.20254, 41.456626],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.20254, 41.456626], logicalId: 32, physicalId: 'SCG-R32' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.20272, 41.456626], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.20236, 41.456626], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.20254, 41.456756], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.20254, 41.456496], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.20272, 41.457726], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.20236, 41.457726], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.20254, 41.457856], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.20254, 41.457596], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.20382, 41.456626], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.20346, 41.456626], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.20364, 41.456756], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.20364, 41.456496], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.20272, 41.455526], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.20236, 41.455526], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.20254, 41.455656], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.20254, 41.455396], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-33',
    name: 'Regulador 33',
    center: [2.201446, 41.457591],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.201446, 41.457591], logicalId: 33, physicalId: 'SCG-R33' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.201626, 41.457591], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.201266, 41.457591], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.201446, 41.457721], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.201446, 41.457461], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.201626, 41.458691], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.201266, 41.458691], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.201446, 41.458821], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.201446, 41.458561], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.202726, 41.457591], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.202366, 41.457591], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.202546, 41.457721], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.202546, 41.457461], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.201626, 41.456491], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.201266, 41.456491], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.201446, 41.456621], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.201446, 41.456361], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-34',
    name: 'Regulador 34',
    center: [2.198013, 41.457478],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.198013, 41.457478], logicalId: 34, physicalId: 'SCG-R34' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.198193, 41.457478], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.197833, 41.457478], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.198013, 41.457608], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.198013, 41.457348], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.198193, 41.458578], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.197833, 41.458578], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.198013, 41.458708], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.198013, 41.458448], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.199293, 41.457478], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.198933, 41.457478], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.199113, 41.457608], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.199113, 41.457348], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.198193, 41.456378], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.197833, 41.456378], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.198013, 41.456508], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.198013, 41.456248], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-70',
    name: 'Regulador 70',
    center: [2.20064, 41.452277],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.20064, 41.452277], logicalId: 70, physicalId: 'SCG-R70' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.20082, 41.452277], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.20046, 41.452277], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.20064, 41.452407], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.20064, 41.452147], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.20082, 41.453377], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.20046, 41.453377], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.20064, 41.453507], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.20064, 41.453247], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.20192, 41.452277], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.20156, 41.452277], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.20174, 41.452407], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.20174, 41.452147], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.20082, 41.451177], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.20046, 41.451177], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.20064, 41.451307], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.20064, 41.451047], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-2',
    name: 'Regulador 2',
    center: [2.206522, 41.45096],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.206522, 41.45096], logicalId: 2, physicalId: 'SCG-R2' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.206702, 41.45096], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.206342, 41.45096], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.206522, 41.45109], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.206522, 41.45083], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.206702, 41.45206], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.206342, 41.45206], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.206522, 41.45219], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.206522, 41.45193], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.207802, 41.45096], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.207442, 41.45096], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.207622, 41.45109], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.207622, 41.45083], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.206702, 41.44986], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.206342, 41.44986], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.206522, 41.44999], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.206522, 41.44973], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-11',
    name: 'Regulador 11',
    center: [2.206975, 41.449948],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.206975, 41.449948], logicalId: 11, physicalId: 'SCG-R11' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.207155, 41.449948], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.206795, 41.449948], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.206975, 41.450078], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.206975, 41.449818], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.207155, 41.451048], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.206795, 41.451048], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.206975, 41.451178], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.206975, 41.450918], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.208255, 41.449948], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.207895, 41.449948], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.208075, 41.450078], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.208075, 41.449818], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.207155, 41.448848], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.206795, 41.448848], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.206975, 41.448978], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.206975, 41.448718], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-12',
    name: 'Regulador 12',
    center: [2.207579, 41.448615],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.207579, 41.448615], logicalId: 12, physicalId: 'SCG-R12' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.207759, 41.448615], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.207399, 41.448615], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.207579, 41.448745], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.207579, 41.448485], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.207759, 41.449715], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.207399, 41.449715], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.207579, 41.449845], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.207579, 41.449585], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.208859, 41.448615], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.208499, 41.448615], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.208679, 41.448745], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.208679, 41.448485], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.207759, 41.447515], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.207399, 41.447515], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.207579, 41.447645], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.207579, 41.447385], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-13',
    name: 'Regulador 13',
    center: [2.208192, 41.447398],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.208192, 41.447398], logicalId: 13, physicalId: 'SCG-R13' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.208372, 41.447398], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.208012, 41.447398], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.208192, 41.447528], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.208192, 41.447268], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.208372, 41.448498], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.208012, 41.448498], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.208192, 41.448628], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.208192, 41.448368], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.209472, 41.447398], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.209112, 41.447398], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.209292, 41.447528], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.209292, 41.447268], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.208372, 41.446298], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.208012, 41.446298], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.208192, 41.446428], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.208192, 41.446168], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-14',
    name: 'Regulador 14',
    center: [2.209099, 41.445471],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.209099, 41.445471], logicalId: 14, physicalId: 'SCG-R14' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.209279, 41.445471], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.208919, 41.445471], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.209099, 41.445601], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.209099, 41.445341], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.209279, 41.446571], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.208919, 41.446571], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.209099, 41.446701], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.209099, 41.446441], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.210379, 41.445471], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.210019, 41.445471], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.210199, 41.445601], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.210199, 41.445341], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.209279, 41.444371], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.208919, 41.444371], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.209099, 41.444501], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.209099, 41.444241], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-15',
    name: 'Regulador 15',
    center: [2.20985, 41.444517],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.20985, 41.444517], logicalId: 15, physicalId: 'SCG-R15' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.21003, 41.444517], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.20967, 41.444517], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.20985, 41.444647], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.20985, 41.444387], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.21003, 41.445617], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.20967, 41.445617], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.20985, 41.445747], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.20985, 41.445487], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.21113, 41.444517], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.21077, 41.444517], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.21095, 41.444647], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.21095, 41.444387], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.21003, 41.443417], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.20967, 41.443417], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.20985, 41.443547], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.20985, 41.443287], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-16',
    name: 'Regulador 16',
    center: [2.211104, 41.443372],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.211104, 41.443372], logicalId: 16, physicalId: 'SCG-R16' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.211284, 41.443372], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.210924, 41.443372], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.211104, 41.443502], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.211104, 41.443242], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.211284, 41.444472], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.210924, 41.444472], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.211104, 41.444602], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.211104, 41.444342], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.212384, 41.443372], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.212024, 41.443372], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.212204, 41.443502], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.212204, 41.443242], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.211284, 41.442272], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.210924, 41.442272], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.211104, 41.442402], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.211104, 41.442142], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-17',
    name: 'Regulador 17',
    center: [2.21054, 41.442006],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.21054, 41.442006], logicalId: 17, physicalId: 'SCG-R17' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.21072, 41.442006], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.21036, 41.442006], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.21054, 41.442136], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.21054, 41.441876], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.21072, 41.443106], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.21036, 41.443106], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.21054, 41.443236], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.21054, 41.442976], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.21182, 41.442006], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.21146, 41.442006], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.21164, 41.442136], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.21164, 41.441876], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.21072, 41.440906], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.21036, 41.440906], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.21054, 41.441036], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.21054, 41.440776], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-18',
    name: 'Regulador 18',
    center: [2.210757, 41.441285],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.210757, 41.441285], logicalId: 18, physicalId: 'SCG-R18' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.210937, 41.441285], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.210577, 41.441285], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.210757, 41.441415], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.210757, 41.441155], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.210937, 41.442385], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.210577, 41.442385], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.210757, 41.442515], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.210757, 41.442255], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.212037, 41.441285], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.211677, 41.441285], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.211857, 41.441415], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.211857, 41.441155], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.210937, 41.440185], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.210577, 41.440185], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.210757, 41.440315], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.210757, 41.440055], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-19',
    name: 'Regulador 19',
    center: [2.210883, 41.439259],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.210883, 41.439259], logicalId: 19, physicalId: 'SCG-R19' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.211063, 41.439259], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.210703, 41.439259], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.210883, 41.439389], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.210883, 41.439129], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.211063, 41.440359], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.210703, 41.440359], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.210883, 41.440489], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.210883, 41.440229], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.212163, 41.439259], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.211803, 41.439259], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.211983, 41.439389], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.211983, 41.439129], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.211063, 41.438159], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.210703, 41.438159], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.210883, 41.438289], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.210883, 41.438029], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-1',
    name: 'Regulador 1',
    center: [2.205174, 41.45025],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.205174, 41.45025], logicalId: 1, physicalId: 'SCG-R1' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.205354, 41.45025], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.204994, 41.45025], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.205174, 41.45038], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.205174, 41.45012], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.205354, 41.45135], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.204994, 41.45135], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.205174, 41.45148], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.205174, 41.45122], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.206454, 41.45025], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.206094, 41.45025], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.206274, 41.45038], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.206274, 41.45012], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.205354, 41.44915], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.204994, 41.44915], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.205174, 41.44928], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.205174, 41.44902], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-0',
    name: 'Regulador 0',
    center: [2.203124, 41.449801],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.203124, 41.449801], logicalId: 0, physicalId: 'SCG-R0' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.203304, 41.449801], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.202944, 41.449801], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.203124, 41.449931], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.203124, 41.449671], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.203304, 41.450901], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.202944, 41.450901], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.203124, 41.451031], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.203124, 41.450771], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.204404, 41.449801], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.204044, 41.449801], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.204224, 41.449931], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.204224, 41.449671], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.203304, 41.448701], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.202944, 41.448701], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.203124, 41.448831], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.203124, 41.448571], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-50',
    name: 'Regulador 50',
    center: [2.203767, 41.448978],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.203767, 41.448978], logicalId: 50, physicalId: 'SCG-R50' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.203947, 41.448978], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.203587, 41.448978], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.203767, 41.449108], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.203767, 41.448848], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.203947, 41.450078], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.203587, 41.450078], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.203767, 41.450208], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.203767, 41.449948], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.205047, 41.448978], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.204687, 41.448978], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.204867, 41.449108], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.204867, 41.448848], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.203947, 41.447878], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.203587, 41.447878], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.203767, 41.448008], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.203767, 41.447748], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-54',
    name: 'Regulador 54',
    center: [2.208929, 41.443812],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.208929, 41.443812], logicalId: 54, physicalId: 'SCG-R54' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.209109, 41.443812], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.208749, 41.443812], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.208929, 41.443942], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.208929, 41.443682], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.209109, 41.444912], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.208749, 41.444912], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.208929, 41.445042], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.208929, 41.444782], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.210209, 41.443812], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.209849, 41.443812], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.210029, 41.443942], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.210029, 41.443682], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.209109, 41.442712], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.208749, 41.442712], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.208929, 41.442842], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.208929, 41.442582], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-53',
    name: 'Regulador 53',
    center: [2.207561, 41.444906],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.207561, 41.444906], logicalId: 53, physicalId: 'SCG-R53' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.207741, 41.444906], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.207381, 41.444906], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.207561, 41.445036], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.207561, 41.444776], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.207741, 41.446006], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.207381, 41.446006], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.207561, 41.446136], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.207561, 41.445876], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.208841, 41.444906], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.208481, 41.444906], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.208661, 41.445036], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.208661, 41.444776], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.207741, 41.443806], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.207381, 41.443806], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.207561, 41.443936], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.207561, 41.443676], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-52',
    name: 'Regulador 52',
    center: [2.205858, 41.446572],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.205858, 41.446572], logicalId: 52, physicalId: 'SCG-R52' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.206038, 41.446572], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.205678, 41.446572], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.205858, 41.446702], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.205858, 41.446442], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.206038, 41.447672], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.205678, 41.447672], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.205858, 41.447802], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.205858, 41.447542], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.207138, 41.446572], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.206778, 41.446572], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.206958, 41.446702], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.206958, 41.446442], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.206038, 41.445472], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.205678, 41.445472], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.205858, 41.445602], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.205858, 41.445342], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-51',
    name: 'Regulador 51',
    center: [2.204764, 41.447734],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.204764, 41.447734], logicalId: 51, physicalId: 'SCG-R51' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.204944, 41.447734], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.204584, 41.447734], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.204764, 41.447864], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.204764, 41.447604], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.204944, 41.448834], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.204584, 41.448834], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.204764, 41.448964], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.204764, 41.448704], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.206044, 41.447734], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.205684, 41.447734], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.205864, 41.447864], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.205864, 41.447604], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.204944, 41.446634], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.204584, 41.446634], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.204764, 41.446764], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.204764, 41.446504], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-72',
    name: 'Regulador 72',
    center: [2.202125, 41.450808],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.202125, 41.450808], logicalId: 72, physicalId: 'SCG-R72' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.202305, 41.450808], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.201945, 41.450808], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.202125, 41.450938], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.202125, 41.450678], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.202305, 41.451908], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.201945, 41.451908], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.202125, 41.452038], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.202125, 41.451778], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.203405, 41.450808], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.203045, 41.450808], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.203225, 41.450938], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.203225, 41.450678], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.202305, 41.449708], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.201945, 41.449708], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.202125, 41.449838], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.202125, 41.449578], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-55',
    name: 'Regulador 55',
    center: [2.209466, 41.442142],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.209466, 41.442142], logicalId: 55, physicalId: 'SCG-R55' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.209646, 41.442142], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.209286, 41.442142], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.209466, 41.442272], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.209466, 41.442012], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.209646, 41.443242], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.209286, 41.443242], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.209466, 41.443372], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.209466, 41.443112], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.210746, 41.442142], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.210386, 41.442142], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.210566, 41.442272], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.210566, 41.442012], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.209646, 41.441042], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.209286, 41.441042], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.209466, 41.441172], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.209466, 41.440912], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-21',
    name: 'Regulador 21',
    center: [2.206122, 41.451631],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.206122, 41.451631], logicalId: 21, physicalId: 'SCG-R21' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.206302, 41.451631], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.205942, 41.451631], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.206122, 41.451761], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.206122, 41.451501], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.206302, 41.452731], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.205942, 41.452731], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.206122, 41.452861], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.206122, 41.452601], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.207402, 41.451631], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.207042, 41.451631], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.207222, 41.451761], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.207222, 41.451501], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.206302, 41.450531], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.205942, 41.450531], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.206122, 41.450661], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.206122, 41.450401], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-3',
    name: 'Regulador 3',
    center: [2.208076, 41.451198],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.208076, 41.451198], logicalId: 3, physicalId: 'SCG-R3' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.208256, 41.451198], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.207896, 41.451198], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.208076, 41.451328], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.208076, 41.451068], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.208256, 41.452298], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.207896, 41.452298], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.208076, 41.452428], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.208076, 41.452168], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.209356, 41.451198], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.208996, 41.451198], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.209176, 41.451328], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.209176, 41.451068], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.208256, 41.450098], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.207896, 41.450098], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.208076, 41.450228], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.208076, 41.449968], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-4',
    name: 'Regulador 4',
    center: [2.209648, 41.451141],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.209648, 41.451141], logicalId: 4, physicalId: 'SCG-R4' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.209828, 41.451141], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.209468, 41.451141], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.209648, 41.451271], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.209648, 41.451011], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.209828, 41.452241], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.209468, 41.452241], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.209648, 41.452371], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.209648, 41.452111], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.210928, 41.451141], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.210568, 41.451141], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.210748, 41.451271], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.210748, 41.451011], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.209828, 41.450041], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.209468, 41.450041], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.209648, 41.450171], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.209648, 41.449911], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-5',
    name: 'Regulador 5',
    center: [2.211232, 41.450729],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.211232, 41.450729], logicalId: 5, physicalId: 'SCG-R5' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.211412, 41.450729], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.211052, 41.450729], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.211232, 41.450859], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.211232, 41.450599], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.211412, 41.451829], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.211052, 41.451829], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.211232, 41.451959], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.211232, 41.451699], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.212512, 41.450729], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.212152, 41.450729], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.212332, 41.450859], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.212332, 41.450599], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.211412, 41.449629], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.211052, 41.449629], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.211232, 41.449759], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.211232, 41.449499], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-6',
    name: 'Regulador 6',
    center: [2.212301, 41.450712],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.212301, 41.450712], logicalId: 6, physicalId: 'SCG-R6' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.212481, 41.450712], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.212121, 41.450712], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.212301, 41.450842], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.212301, 41.450582], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.212481, 41.451812], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.212121, 41.451812], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.212301, 41.451942], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.212301, 41.451682], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.213581, 41.450712], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.213221, 41.450712], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.213401, 41.450842], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.213401, 41.450582], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.212481, 41.449612], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.212121, 41.449612], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.212301, 41.449742], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.212301, 41.449482], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-7',
    name: 'Regulador 7',
    center: [2.213718, 41.450694],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.213718, 41.450694], logicalId: 7, physicalId: 'SCG-R7' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.213898, 41.450694], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.213538, 41.450694], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.213718, 41.450824], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.213718, 41.450564], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.213898, 41.451794], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.213538, 41.451794], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.213718, 41.451924], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.213718, 41.451664], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.214998, 41.450694], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.214638, 41.450694], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.214818, 41.450824], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.214818, 41.450564], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.213898, 41.449594], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.213538, 41.449594], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.213718, 41.449724], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.213718, 41.449464], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-63',
    name: 'Regulador 63',
    center: [2.213392, 41.451286],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.213392, 41.451286], logicalId: 63, physicalId: 'SCG-R63' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.213572, 41.451286], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.213212, 41.451286], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.213392, 41.451416], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.213392, 41.451156], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.213572, 41.452386], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.213212, 41.452386], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.213392, 41.452516], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.213392, 41.452256], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.214672, 41.451286], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.214312, 41.451286], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.214492, 41.451416], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.214492, 41.451156], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.213572, 41.450186], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.213212, 41.450186], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.213392, 41.450316], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.213392, 41.450056], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-60',
    name: 'Regulador 60',
    center: [2.21416, 41.449369],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.21416, 41.449369], logicalId: 60, physicalId: 'SCG-R60' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.21434, 41.449369], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.21398, 41.449369], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.21416, 41.449499], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.21416, 41.449239], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.21434, 41.450469], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.21398, 41.450469], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.21416, 41.450599], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.21416, 41.450339], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.21544, 41.449369], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.21508, 41.449369], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.21526, 41.449499], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.21526, 41.449239], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.21434, 41.448269], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.21398, 41.448269], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.21416, 41.448399], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.21416, 41.448139], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-61',
    name: 'Regulador 61',
    center: [2.214795, 41.447702],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.214795, 41.447702], logicalId: 61, physicalId: 'SCG-R61' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.214975, 41.447702], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.214615, 41.447702], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.214795, 41.447832], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.214795, 41.447572], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.214975, 41.448802], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.214615, 41.448802], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.214795, 41.448932], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.214795, 41.448672], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.216075, 41.447702], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.215715, 41.447702], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.215895, 41.447832], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.215895, 41.447572], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.214975, 41.446602], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.214615, 41.446602], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.214795, 41.446732], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.214795, 41.446472], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-62',
    name: 'Regulador 62',
    center: [2.21535, 41.446828],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.21535, 41.446828], logicalId: 62, physicalId: 'SCG-R62' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.21553, 41.446828], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.21517, 41.446828], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.21535, 41.446958], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.21535, 41.446698], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.21553, 41.447928], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.21517, 41.447928], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.21535, 41.448058], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.21535, 41.447798], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.21663, 41.446828], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.21627, 41.446828], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.21645, 41.446958], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.21645, 41.446698], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.21553, 41.445728], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.21517, 41.445728], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.21535, 41.445858], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.21535, 41.445598], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-42',
    name: 'Regulador 42',
    center: [2.210324, 41.447951],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.210324, 41.447951], logicalId: 42, physicalId: 'SCG-R42' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.210504, 41.447951], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.210144, 41.447951], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.210324, 41.448081], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.210324, 41.447821], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.210504, 41.449051], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.210144, 41.449051], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.210324, 41.449181], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.210324, 41.448921], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.211604, 41.447951], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.211244, 41.447951], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.211424, 41.448081], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.211424, 41.447821], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.210504, 41.446851], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.210144, 41.446851], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.210324, 41.446981], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.210324, 41.446721], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-43',
    name: 'Regulador 43',
    center: [2.210644, 41.447369],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.210644, 41.447369], logicalId: 43, physicalId: 'SCG-R43' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.210824, 41.447369], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.210464, 41.447369], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.210644, 41.447499], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.210644, 41.447239], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.210824, 41.448469], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.210464, 41.448469], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.210644, 41.448599], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.210644, 41.448339], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.211924, 41.447369], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.211564, 41.447369], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.211744, 41.447499], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.211744, 41.447239], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.210824, 41.446269], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.210464, 41.446269], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.210644, 41.446399], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.210644, 41.446139], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-8',
    name: 'Regulador 8',
    center: [2.215101, 41.451082],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.215101, 41.451082], logicalId: 8, physicalId: 'SCG-R8' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.215281, 41.451082], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.214921, 41.451082], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.215101, 41.451212], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.215101, 41.450952], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.215281, 41.452182], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.214921, 41.452182], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.215101, 41.452312], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.215101, 41.452052], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.216381, 41.451082], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.216021, 41.451082], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.216201, 41.451212], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.216201, 41.450952], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.215281, 41.449982], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.214921, 41.449982], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.215101, 41.450112], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.215101, 41.449852], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-80',
    name: 'Regulador 80',
    center: [2.215889, 41.451069],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.215889, 41.451069], logicalId: 80, physicalId: 'SCG-R80' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.216069, 41.451069], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.215709, 41.451069], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.215889, 41.451199], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.215889, 41.450939], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.216069, 41.452169], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.215709, 41.452169], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.215889, 41.452299], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.215889, 41.452039], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.217169, 41.451069], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.216809, 41.451069], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.216989, 41.451199], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.216989, 41.450939], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.216069, 41.449969], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.215709, 41.449969], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.215889, 41.450099], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.215889, 41.449839], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-81',
    name: 'Regulador 81',
    center: [2.217491, 41.451308],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.217491, 41.451308], logicalId: 81, physicalId: 'SCG-R81' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.217671, 41.451308], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.217311, 41.451308], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.217491, 41.451438], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.217491, 41.451178], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.217671, 41.452408], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.217311, 41.452408], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.217491, 41.452538], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.217491, 41.452278], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.218771, 41.451308], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.218411, 41.451308], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.218591, 41.451438], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.218591, 41.451178], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.217671, 41.450208], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.217311, 41.450208], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.217491, 41.450338], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.217491, 41.450078], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-82',
    name: 'Regulador 82',
    center: [2.218126, 41.451455],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.218126, 41.451455], logicalId: 82, physicalId: 'SCG-R82' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.218306, 41.451455], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.217946, 41.451455], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.218126, 41.451585], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.218126, 41.451325], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.218306, 41.452555], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.217946, 41.452555], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.218126, 41.452685], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.218126, 41.452425], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.219406, 41.451455], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.219046, 41.451455], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.219226, 41.451585], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.219226, 41.451325], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.218306, 41.450355], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.217946, 41.450355], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.218126, 41.450485], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.218126, 41.450225], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-83',
    name: 'Regulador 83',
    center: [2.219254, 41.451586],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.219254, 41.451586], logicalId: 83, physicalId: 'SCG-R83' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.219434, 41.451586], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.219074, 41.451586], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.219254, 41.451716], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.219254, 41.451456], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.219434, 41.452686], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.219074, 41.452686], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.219254, 41.452816], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.219254, 41.452556], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.220534, 41.451586], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.220174, 41.451586], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.220354, 41.451716], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.220354, 41.451456], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.219434, 41.450486], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.219074, 41.450486], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.219254, 41.450616], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.219254, 41.450356], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-44',
    name: 'Regulador 44',
    center: [2.212208, 41.447424],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.212208, 41.447424], logicalId: 44, physicalId: 'SCG-R44' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.212388, 41.447424], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.212028, 41.447424], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.212208, 41.447554], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.212208, 41.447294], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.212388, 41.448524], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.212028, 41.448524], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.212208, 41.448654], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.212208, 41.448394], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.213488, 41.447424], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.213128, 41.447424], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.213308, 41.447554], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.213308, 41.447294], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.212388, 41.446324], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.212028, 41.446324], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.212208, 41.446454], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.212208, 41.446194], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-45',
    name: 'Regulador 45',
    center: [2.213539, 41.446305],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.213539, 41.446305], logicalId: 45, physicalId: 'SCG-R45' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.213719, 41.446305], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.213359, 41.446305], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.213539, 41.446435], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.213539, 41.446175], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.213719, 41.447405], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.213359, 41.447405], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.213539, 41.447535], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.213539, 41.447275], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.214819, 41.446305], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.214459, 41.446305], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.214639, 41.446435], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.214639, 41.446175], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.213719, 41.445205], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.213359, 41.445205], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.213539, 41.445335], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.213539, 41.445075], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-86',
    name: 'Regulador 86',
    center: [2.220307, 41.452223],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.220307, 41.452223], logicalId: 86, physicalId: 'SCG-R86' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.220487, 41.452223], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.220127, 41.452223], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.220307, 41.452353], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.220307, 41.452093], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.220487, 41.453323], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.220127, 41.453323], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.220307, 41.453453], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.220307, 41.453193], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.221587, 41.452223], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.221227, 41.452223], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.221407, 41.452353], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.221407, 41.452093], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.220487, 41.451123], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.220127, 41.451123], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.220307, 41.451253], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.220307, 41.450993], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-47',
    name: 'Regulador 47',
    center: [2.212701, 41.445995],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.212701, 41.445995], logicalId: 47, physicalId: 'SCG-R47' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.212881, 41.445995], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.212521, 41.445995], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.212701, 41.446125], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.212701, 41.445865], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.212881, 41.447095], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.212521, 41.447095], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.212701, 41.447225], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.212701, 41.446965], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.213981, 41.445995], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.213621, 41.445995], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.213801, 41.446125], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.213801, 41.445865], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.212881, 41.444895], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.212521, 41.444895], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.212701, 41.445025], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.212701, 41.444765], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-46',
    name: 'Regulador 46',
    center: [2.211039, 41.446069],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.211039, 41.446069], logicalId: 46, physicalId: 'SCG-R46' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.211219, 41.446069], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.210859, 41.446069], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.211039, 41.446199], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.211039, 41.445939], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.211219, 41.447169], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.210859, 41.447169], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.211039, 41.447299], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.211039, 41.447039], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.212319, 41.446069], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.211959, 41.446069], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.212139, 41.446199], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.212139, 41.445939], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.211219, 41.444969], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.210859, 41.444969], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.211039, 41.445099], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.211039, 41.444839], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-201',
    name: 'Regulador 201',
    center: [2.214552, 41.441596],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.214552, 41.441596], logicalId: 201, physicalId: 'SCG-R201' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.214732, 41.441596], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.214372, 41.441596], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.214552, 41.441726], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.214552, 41.441466], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.214732, 41.442696], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.214372, 41.442696], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.214552, 41.442826], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.214552, 41.442566], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.215832, 41.441596], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.215472, 41.441596], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.215652, 41.441726], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.215652, 41.441466], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.214732, 41.440496], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.214372, 41.440496], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.214552, 41.440626], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.214552, 41.440366], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-202',
    name: 'Regulador 202',
    center: [2.215864, 41.442846],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.215864, 41.442846], logicalId: 202, physicalId: 'SCG-R202' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.216044, 41.442846], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.215684, 41.442846], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.215864, 41.442976], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.215864, 41.442716], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.216044, 41.443946], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.215684, 41.443946], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.215864, 41.444076], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.215864, 41.443816], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.217144, 41.442846], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.216784, 41.442846], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.216964, 41.442976], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.216964, 41.442716], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.216044, 41.441746], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.215684, 41.441746], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.215864, 41.441876], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.215864, 41.441616], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-203',
    name: 'Regulador 203',
    center: [2.217043, 41.443967],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.217043, 41.443967], logicalId: 203, physicalId: 'SCG-R203' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.217223, 41.443967], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.216863, 41.443967], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.217043, 41.444097], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.217043, 41.443837], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.217223, 41.445067], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.216863, 41.445067], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.217043, 41.445197], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.217043, 41.444937], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.218323, 41.443967], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.217963, 41.443967], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.218143, 41.444097], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.218143, 41.443837], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.217223, 41.442867], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.216863, 41.442867], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.217043, 41.442997], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.217043, 41.442737], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-204',
    name: 'Regulador 204',
    center: [2.217689, 41.444601],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.217689, 41.444601], logicalId: 204, physicalId: 'SCG-R204' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.217869, 41.444601], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.217509, 41.444601], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.217689, 41.444731], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.217689, 41.444471], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.217869, 41.445701], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.217509, 41.445701], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.217689, 41.445831], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.217689, 41.445571], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.218969, 41.444601], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.218609, 41.444601], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.218789, 41.444731], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.218789, 41.444471], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.217869, 41.443501], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.217509, 41.443501], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.217689, 41.443631], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.217689, 41.443371], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-205',
    name: 'Regulador 205',
    center: [2.21957, 41.44627],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.21957, 41.44627], logicalId: 205, physicalId: 'SCG-R205' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.21975, 41.44627], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.21939, 41.44627], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.21957, 41.4464], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.21957, 41.44614], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.21975, 41.44737], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.21939, 41.44737], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.21957, 41.4475], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.21957, 41.44724], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.22085, 41.44627], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.22049, 41.44627], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.22067, 41.4464], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.22067, 41.44614], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.21975, 41.44517], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.21939, 41.44517], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.21957, 41.4453], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.21957, 41.44504], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-206',
    name: 'Regulador 206',
    center: [2.220929, 41.447383],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.220929, 41.447383], logicalId: 206, physicalId: 'SCG-R206' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.221109, 41.447383], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.220749, 41.447383], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.220929, 41.447513], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.220929, 41.447253], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.221109, 41.448483], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.220749, 41.448483], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.220929, 41.448613], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.220929, 41.448353], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.222209, 41.447383], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.221849, 41.447383], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.222029, 41.447513], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.222029, 41.447253], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.221109, 41.446283], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.220749, 41.446283], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.220929, 41.446413], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.220929, 41.446153], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-84',
    name: 'Regulador 84',
    center: [2.219351, 41.449998],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.219351, 41.449998], logicalId: 84, physicalId: 'SCG-R84' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.219531, 41.449998], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.219171, 41.449998], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.219351, 41.450128], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.219351, 41.449868], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.219531, 41.451098], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.219171, 41.451098], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.219351, 41.451228], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.219351, 41.450968], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.220631, 41.449998], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.220271, 41.449998], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.220451, 41.450128], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.220451, 41.449868], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.219531, 41.448898], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.219171, 41.448898], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.219351, 41.449028], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.219351, 41.448768], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-85',
    name: 'Regulador 85',
    center: [2.218992, 41.454271],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.218992, 41.454271], logicalId: 85, physicalId: 'SCG-R85' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.219172, 41.454271], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.218812, 41.454271], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.218992, 41.454401], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.218992, 41.454141], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.219172, 41.455371], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.218812, 41.455371], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.218992, 41.455501], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.218992, 41.455241], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.220272, 41.454271], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.219912, 41.454271], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.220092, 41.454401], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.220092, 41.454141], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.219172, 41.453171], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.218812, 41.453171], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.218992, 41.453301], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.218992, 41.453041], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-10',
    name: 'Regulador 10',
    center: [2.217462, 41.452965],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.217462, 41.452965], logicalId: 10, physicalId: 'SCG-R10' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.217642, 41.452965], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.217282, 41.452965], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.217462, 41.453095], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.217462, 41.452835], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.217642, 41.454065], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.217282, 41.454065], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.217462, 41.454195], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.217462, 41.453935], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.218742, 41.452965], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.218382, 41.452965], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.218562, 41.453095], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.218562, 41.452835], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.217642, 41.451865], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.217282, 41.451865], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.217462, 41.451995], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.217462, 41.451735], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-106',
    name: 'Regulador 106',
    center: [2.214833, 41.4565],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.214833, 41.4565], logicalId: 106, physicalId: 'SCG-R106' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.215013, 41.4565], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.214653, 41.4565], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.214833, 41.45663], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.214833, 41.45637], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.215013, 41.4576], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.214653, 41.4576], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.214833, 41.45773], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.214833, 41.45747], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.216113, 41.4565], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.215753, 41.4565], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.215933, 41.45663], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.215933, 41.45637], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.215013, 41.4554], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.214653, 41.4554], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.214833, 41.45553], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.214833, 41.45527], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-56',
    name: 'Regulador 56',
    center: [2.214342, 41.435238],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.214342, 41.435238], logicalId: 56, physicalId: 'SCG-R56' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.214522, 41.435238], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.214162, 41.435238], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.214342, 41.435368], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.214342, 41.435108], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.214522, 41.436338], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.214162, 41.436338], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.214342, 41.436468], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.214342, 41.436208], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.215622, 41.435238], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.215262, 41.435238], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.215442, 41.435368], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.215442, 41.435108], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.214522, 41.434138], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.214162, 41.434138], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.214342, 41.434268], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.214342, 41.434008], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-94',
    name: 'Regulador 94',
    center: [2.205137, 41.460208],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.205137, 41.460208], logicalId: 94, physicalId: 'SCG-R94' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.205317, 41.460208], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.204957, 41.460208], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.205137, 41.460338], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.205137, 41.460078], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.205317, 41.461308], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.204957, 41.461308], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.205137, 41.461438], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.205137, 41.461178], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.206417, 41.460208], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.206057, 41.460208], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.206237, 41.460338], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.206237, 41.460078], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.205317, 41.459108], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.204957, 41.459108], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.205137, 41.459238], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.205137, 41.458978], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-95',
    name: 'Regulador 95',
    center: [2.202318, 41.460529],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.202318, 41.460529], logicalId: 95, physicalId: 'SCG-R95' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.202498, 41.460529], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.202138, 41.460529], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.202318, 41.460659], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.202318, 41.460399], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.202498, 41.461629], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.202138, 41.461629], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.202318, 41.461759], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.202318, 41.461499], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.203598, 41.460529], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.203238, 41.460529], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.203418, 41.460659], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.203418, 41.460399], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.202498, 41.459429], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.202138, 41.459429], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.202318, 41.459559], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.202318, 41.459299], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-36',
    name: 'Regulador 36',
    center: [2.201633, 41.458922],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 0,
    cabinet: { position: [2.201633, 41.458922], logicalId: 36, physicalId: 'SCG-R36' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.201813, 41.458922], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.201453, 41.458922], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.201633, 41.459052], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.201633, 41.458792], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.201813, 41.460022], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.201453, 41.460022], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.201633, 41.460152], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.201633, 41.459892], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.202913, 41.458922], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.202553, 41.458922], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.202733, 41.459052], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.202733, 41.458792], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.201813, 41.457822], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.201453, 41.457822], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.201633, 41.457952], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.201633, 41.457692], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-35',
    name: 'Regulador 35',
    center: [2.195441, 41.458674],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.195441, 41.458674], logicalId: 35, physicalId: 'SCG-R35' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.195621, 41.458674], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.195261, 41.458674], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.195441, 41.458804], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.195441, 41.458544], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.195621, 41.459774], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.195261, 41.459774], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.195441, 41.459904], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.195441, 41.459644], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.196721, 41.458674], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.196361, 41.458674], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.196541, 41.458804], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.196541, 41.458544], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.195621, 41.457574], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.195261, 41.457574], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.195441, 41.457704], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.195441, 41.457444], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-74',
    name: 'Regulador 74',
    center: [2.19821, 41.453798],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.19821, 41.453798], logicalId: 74, physicalId: 'SCG-R74' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.19839, 41.453798], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.19803, 41.453798], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.19821, 41.453928], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.19821, 41.453668], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.19839, 41.454898], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.19803, 41.454898], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.19821, 41.455028], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.19821, 41.454768], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.19949, 41.453798], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.19913, 41.453798], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.19931, 41.453928], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.19931, 41.453668], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.19839, 41.452698], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.19803, 41.452698], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.19821, 41.452828], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.19821, 41.452568], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-103',
    name: 'Regulador 103',
    center: [2.194687, 41.456659],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 3,
    cabinet: { position: [2.194687, 41.456659], logicalId: 103, physicalId: 'SCG-R103' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.194867, 41.456659], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.194507, 41.456659], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.194687, 41.456789], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.194687, 41.456529], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.194867, 41.457759], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.194507, 41.457759], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.194687, 41.457889], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.194687, 41.457629], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.195967, 41.456659], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.195607, 41.456659], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.195787, 41.456789], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.195787, 41.456529], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.194867, 41.455559], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.194507, 41.455559], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.194687, 41.455689], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.194687, 41.455429], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-105',
    name: 'Regulador 105',
    center: [2.191904, 41.460639],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.191904, 41.460639], logicalId: 105, physicalId: 'SCG-R105' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.192084, 41.460639], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.191724, 41.460639], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.191904, 41.460769], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.191904, 41.460509], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.192084, 41.461739], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.191724, 41.461739], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.191904, 41.461869], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.191904, 41.461609], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.193184, 41.460639], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.192824, 41.460639], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.193004, 41.460769], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.193004, 41.460509], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.192084, 41.459539], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.191724, 41.459539], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.191904, 41.459669], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.191904, 41.459409], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-102',
    name: 'Regulador 102',
    center: [2.190405, 41.461546],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 2,
    cabinet: { position: [2.190405, 41.461546], logicalId: 102, physicalId: 'SCG-R102' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.190585, 41.461546], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.190225, 41.461546], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.190405, 41.461676], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.190405, 41.461416], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.190585, 41.462646], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.190225, 41.462646], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.190405, 41.462776], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.190405, 41.462516], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.191685, 41.461546], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.191325, 41.461546], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.191505, 41.461676], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.191505, 41.461416], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.190585, 41.460446], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.190225, 41.460446], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.190405, 41.460576], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.190405, 41.460316], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  },
  {
    id: 'scg-reg-101',
    name: 'Regulador 101',
    center: [2.211778, 41.453224],
    zoom: 18.5, bearing: 0, pitch: 50,
    phaseOffset: 1,
    cabinet: { position: [2.211778, 41.453224], logicalId: 101, physicalId: 'SCG-R101' },
    groups: [
      { id: 1, type: 'V', label: 'G1', position: [2.211958, 41.453224], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 2, type: 'V', label: 'G2', position: [2.211598, 41.453224], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 3, type: 'V', label: 'G3', position: [2.211778, 41.453354], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 4, type: 'V', label: 'G4', position: [2.211778, 41.453094], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 5, type: 'V', label: 'G5', position: [2.211958, 41.454324], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 6, type: 'V', label: 'G6', position: [2.211598, 41.454324], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 7, type: 'V', label: 'G7', position: [2.211778, 41.454454], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 8, type: 'V', label: 'G8', position: [2.211778, 41.454194], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 9, type: 'V', label: 'G9', position: [2.213058, 41.453224], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 10, type: 'V', label: 'G10', position: [2.212698, 41.453224], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 11, type: 'V', label: 'G11', position: [2.212878, 41.453354], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 12, type: 'V', label: 'G12', position: [2.212878, 41.453094], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 13, type: 'V', label: 'G13', position: [2.211958, 41.452124], bearing: 270,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 14, type: 'V', label: 'G14', position: [2.211598, 41.452124], bearing: 90,
        phaseColors: { F1: CC.V, F2: CC.A, F3: CC.R, F4: CC.R } },
      { id: 15, type: 'V', label: 'G15', position: [2.211778, 41.452254], bearing: 180,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
      { id: 16, type: 'V', label: 'G16', position: [2.211778, 41.451994], bearing: 0,
        phaseColors: { F1: CC.R, F2: CC.R, F3: CC.V, F4: CC.A } },
    ],
    detectors: [],
    geometry: EMPTY_GEOMETRY,
  }
];
